import React from 'react';
import { Box, List, Typography } from '@mui/material';
import HomeListItem from './HomeListItem';
import { formatDateLong } from '../utils/lib';
import { useTranslation } from 'react-i18next';

const HomeList = ({notifications, onClick}) => {
  const { i18n } = useTranslation();

  const today = new Date();
  const date = formatDateLong(today.toString());
  const firstNotif = { 
    notification_type: 'DAILY_SUMMARY', 
    notification_es: i18n.getFixedT('es')('layouts.daySummary') + date.toString(),
    notification_en: i18n.getFixedT('en')('layouts.daySummary') + date.toString(),
    notification_pt: i18n.getFixedT('pt')('layouts.daySummary') + date.toString(),
    notification_clickable: false
  };
  notifications = [firstNotif, ...notifications];

  return (
    <Box 
      sx={{ 
        width: '100%', 
      }}>

      <List sx={{ pt: 0 }}>
        {notifications.map((notification, index) => (
          <HomeListItem
            key={index}
            notification={notification}
            onClick={onClick}
          />
        ))}
      </List>
    </Box>
  );
};

export default HomeList;
